(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3D_slider"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper(".slide-container", {
   spaceBetween: 20,
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
  slidesPerView: 4,
  spaceBetween: 20,
  sliderPerGroup: 4,
  loop: true,
  centerSlide: "true",
  fade: "true",
  autoplat:"true",
  grabCursor: "true",
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    520: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1000: {
      slidesPerView: 4,
    },
  },
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team"] && !Shopify.designMode) return;
  try {
    
  const Reveal=()=> {
var reveals = document.querySelectorAll(".reveal");

for (var i = 0; i < reveals.length; i++) {
var windowHeight = window.innerHeight;
var elementTop = reveals[i].getBoundingClientRect().top;
var elementVisible = 30;

if (elementTop < windowHeight - elementVisible) {
reveals[i].classList.add("active");
} else {
reveals[i].classList.remove("active");
}
}
}
window.addEventListener("scroll", Reveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video_grid"]) return;
  try {
    
  $(document).on('click', '.video-thumbnail', function() {
  var videoId = $(this).data('video');
  var videoUrl = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';

  // Display the video in a modal window
  var modalHtml = '<div class="video-modal">' +
                  '<iframe src="' + videoUrl + '" frameborder="0" allow="autoplay; fullscreen"></iframe>' +
                  '</div>';
  $('body').append(modalHtml);

  // Display the video in an embedded player
  var playerHtml = '<div class="video-player">' +
                   '<iframe src="' + videoUrl + '" frameborder="0" allow="autoplay; fullscreen"></iframe>' +
                   '</div>';
  $('.video-player-container').html(playerHtml);
});

  } catch(e) { console.error(e); }
})();
})();
